module.exports = __webpack_public_path__ + "img/header.6259e0ac.png";